import React, { useReducer } from "react";
import TextInput from './TextInput'
import TimeInput from './TimeInput'
import TextNumberInput from './TextNumberInput'
import SelectInput from './SelectInput'
import FixButton from './Button'
import ManageMeetingService from '../services/manageMeeting';
import Cookies from 'universal-cookie';
import moment from 'moment';
import Utils from '../utils/utils';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import getIntermediaries from "../services/getIntermediaries";

export default class EditMeetingWidget extends React.Component {

    constructor (props){
        super(props);

        this.selectRef = React.createRef();
        
        let eventTime = Utils.roundTime(this.props.meeting.hour) + ":" + Utils.roundTime(this.props.meeting.minutes);
        this.renderCount = 0;

        this.subjects = [];
        this.subjectsRepresentative = [];
        this.valueRepresentative = [];
        this.state = {
            visible: false,
            selected: 'event',
            time: eventTime,
            editorState: EditorState.createEmpty()
        }
    }

    async componentDidMount(){
        let scheduleType = this.props.scheduleType;
        this.subjects = [];
        this.savedEnabled = false;
        this.brokersSelected = [];
        var investorsIds = [];

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const eventId = cookies.get('currentEventId', { path: '/' });
        
        this.brokersCompany = await getIntermediaries(username, token, eventId, 'company');
        this.brokersInvestor = await getIntermediaries(username, token, eventId, 'investor');

        if (scheduleType == 'investor'){

            this.renderCount = 2;

            this.optionsLabel = "Company";

            this.props.companies.map(company => {
                var brokers = company.broker_id.split(',');
                this.brokersCompany.forEach(b => {
                    if (brokers.includes(b.id) == false) return;
                    this.subjects.push({broker: b.id, value: company.id.toString() + '-' + b.id.toString(), label: company.company + ' - ' + company.name + ' (Hosted by ' + b.name + ')'})
                });
            });

            this.subjects.forEach(subject => {
                if (this.props.meeting.brokerId != subject.broker) return;
                var tempValue = this.props.meeting.company_id.toString() + '-' + this.props.meeting.brokerId.toString();
                if (tempValue != subject.value) return;
                this.selectedCompany = subject;
            });

            /*
            this.props.companies.map(company => {
                this.subjects.push({value: company.id, label: company.name});
                if (company.id == this.props.meeting.company_id){
                    this.selectedCompany = {value: company.id, label: company.name};
                }
            });
*/
            this.props.investors.map(investor => {
                if (investor.id == this.props.subjectId){
                    this.currentInvestor = investor;
                }
            });

            this.brokerSelectOptions = [];
            this.brokerSelected = [];
            this.brokersInvestor && this.brokersInvestor.forEach(b => {
                if (this.currentInvestor.brokerId.split(',').includes(b.id) == true)
                  this.brokerSelectOptions.push({ value: b.id, label: b.name });
            })

            this.props.meeting.investors.forEach(meetingInvestor => {
                if (meetingInvestor.id != this.currentInvestor.id) return;
                this.brokerSelectOptions.forEach(broker => {
                    if (broker.value != meetingInvestor.brokerId) return;
                    this.brokersSelected.push(broker);

                })
            });
        }

        if (scheduleType == 'company'){
            this.props.companies.map(company => {
                if (company.id == this.props.meeting.company_id){
                    this.currentCompany = company;
                }
            });

            this.optionsLabel = "Investors";
            this.props.investors.map(investor => {
                var brokers = investor.brokerId.split(',');
                this.brokersInvestor.forEach(b => {
                    if (brokers.includes(b.id) == false) return;
                    this.subjects.push({broker: b.id, value: investor.id, label: investor.company + ' - ' + investor.name + ' (Hosted by ' + b.name + ')'})
                });
            });

            this.currentCompany.rapresentative.split(';').map(r => {
                this.subjectsRepresentative.push({value: r, label: r});
                if (this.props.meeting.excludedRapresentatives.split(';').indexOf(r) == -1)
                    this.valueRepresentative.push({value: r, label: r});
            });

            this.brokerSelectOptions = [];
            this.brokerSelected = [];
            this.brokersCompany && this.brokersCompany.forEach(b => {
                if (this.currentCompany.broker_id.split(',').includes(b.id) == true)
                    this.brokerSelectOptions.push({ value: b.id, label: b.name });
            })

            this.brokerSelectOptions.forEach(broker => {
                if (broker.value != this.props.meeting.brokerId) return;
                this.brokersSelected.push({broker: broker.value, label: broker.label})
            })

            this.brokerSelectOptions.forEach(b => {
                if (this.props.meeting.brokerId == b.value)
                    this.setState({brokers: [b]})
            });

            this.setState({
                valueRepresentative: this.valueRepresentative
            })

            this.props.meeting.investors.forEach(meetingInvestor => {
                this.subjects.forEach(subject => {
                    if (meetingInvestor.brokerId != subject.broker) return;
                    if (meetingInvestor.id != subject.value) return;
                    investorsIds.push(subject);
                });
            })
     
        }

        var contentState = {};
        var notes = this.props.meeting.notesRaw;
        console.error("Notes: " + notes);
        if (notes != '') {
            var json = JSON.parse(notes);
            contentState = json;
        } else {
            notes = '{"blocks":[{"key":"","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';
            var json = JSON.parse(notes);
            contentState = json;
        }

        this.setState({
            value: scheduleType == 'company' ? investorsIds : this.selectedCompany,
            visible: this.props.visible,
            scheduleType: scheduleType,
            slots: this.props.meeting.slots,
            contentState: contentState,
            brokers: this.brokersSelected
        });
    }

    shouldComponentUpdate() {
        if (this.renderCount < 3) {
            this.renderCount += 1;
            return true;
        } else {
            return false;
        }
    }

    onContentStateChange = contentState => {
        this.savedEnabled = true;

        var n = contentState; 
        n.blocks.forEach((block) => {
            block.inlineStyleRanges.forEach((s, ind) => {
                if (s.style !== 'BOLD' && s.style !== 'ITALIC' && s.style !== 'UNDERLINE' && !s.style.includes('color-rgb') && !s.style.includes('fontsize') && !s.style.includes('fontfamily')) {
                    s.style = "";
                }
            })

            block.text = block.text.replace(/\n/g, '');
        });
        /*n.blocks.forEach((block, ind) => {
            if (block.text === '') {
                n.blocks.splice(ind, 1);
            }
        });*/

        this.setState({ contentState: n });
    }

    render () {

        if (this.props.meeting == undefined) return null;
        let st = Object.assign({display: this.state.visible ? 'block' : 'none'}, mainClass)

        let meetingTime = Utils.roundTime(this.props.meeting.hour) + ":" + Utils.roundTime(this.props.meeting.minutes);

        return ( 
        <div key={Math.random()} style={st} >
            <div style={closeIcon} onClick={() => {
                this.setState({visible: false});
                this.props.onDone();
            }}>X</div>
            <div style={{overflow: 'hidden', marginTop: '10px', display: this.state.selected == 'event' ? 'block' : 'none'}}>
                <div className="windowTitle">Edit meeting</div>
                <TextInput readOnly={true} name={"Name"} value={this.props.subjectName} />
                
                { this.state.scheduleType == 'company' ?
                    <SelectInput 
                        ref={this.selectRef}
                        value={this.state.valueRepresentative} 
                        name="Representative" 
                        hidable={true}
                        options={this.subjectsRepresentative} 
                        isMulti={true}
                        onChange={(option) => 
                            this.setState({valueRepresentative: option})} 
                        />
                 : null }

                <TextInput readOnly={true} name={"Date"} value={this.props.meeting.date} />
                <TimeInput autoFocus readOnly={true} name={"Time"} value={this.state.time} onChange={(val) => this.setState({time: val}) }/>


                <TextNumberInput name={"Slot duration"} value={this.state.slots * 5} onChange={(val) => 
                    this.setState({slots : val / 5,
                                    value: this.state.value})}/>

                { this.brokerSelectOptions && this.brokerSelectOptions.length > 1 && <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.brokers} 
                    name={"Brokers"} 
                    options={this.brokerSelectOptions} 
                    isMulti={false}
                    onChange={(option) => {
                        this.setState({brokers: [option]});
                      }}
                    />
                    }

                <SelectInput key={2} 
                    ref={this.selectRef}
                    value={this.state.value} 
                    name={this.optionsLabel} 
                    options={this.subjects} 
                    isMulti={this.props.scheduleType == 'company'}
                    onChange={(option) => 
                        this.setState({value: option})} 
                    />

                Notes:
                <div style={{border: '1px solid black', margin: '5px', padding: '10px'}}>
                    
                    <Editor
                        contentState = {this.state.contentState}
                        onContentStateChange={this.onContentStateChange}
                        toolbarClassName="demo-toolbar-custom"
                        wrapperClassName="demo-wrapper"
                        editorClassName="demo-editor-custom"
                        toolbar={{
                            options: ['inline', 'fontSize', 'fontFamily', 'colorPicker', 'link'],       
                            inline: {
                                options: ['bold', 'italic', 'underline'],
                                bold: { className: 'bordered-option-classname' },
                                italic: { className: 'bordered-option-classname' },
                                underline: { className: 'bordered-option-classname' },
                            },
                        }}
                    />
                </div>

                <div style={{marginTop: '5px'}}>
                    <FixButton title={'Save'} callback={this.saveMeeting.bind(this)} />
                    <FixButton title={'Delete'} callback={this.deletePressed.bind(this)} />
                </div>
            </div>
        </div>
        )
    }

    async saveBreak(){

    }

    checkInvestor(investors, id){
        investors.map(v => {
            if (v.id == id) return true;
        });
        return false;
    }

    async deletePressed(){

       if (window.confirm("Delete the meeting?")) {
            if (this.state.scheduleType == 'company') {
                this.deleteMeeting();
            } else {
                if (this.props.meeting.investors.length <= 1)
                    this.deleteMeeting();
                else {
                    var investorsList = this.props.meeting.investors;    
                    var newInvestorsList = [];
                    investorsList.forEach(i => {
                        if (i.id != this.props.subjectId)
                            newInvestorsList.push(i);
                    });
                    this.props.meeting.investors = newInvestorsList;
                    this.saveMeeting();
                }

            }
       }
    }

    async deleteMeeting(){
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const currentEventId = cookies.get('currentEventId', { path: '/' });

        let res = await ManageMeetingService(username, token, currentEventId, this.props.meeting.id, 
            this.props.meeting.date, this.props.meeting.hour, this.props.meeting.minutes, this.state.slots, this.props.meeting.company_id, '', [], [], true);

        this.props.onDone();
    }

    async saveMeeting(){

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const currentEventId = cookies.get('currentEventId', { path: '/' });

        var investorIds = [];
        var investorBrokersIds = [];

        const notesRaw = JSON.stringify(this.state.contentState);
        
        var notes = this.props.meeting.notes;
        if (this.savedEnabled == true){
            var newNote = this.state.contentState;
            notes = draftToHtml(newNote);
            notes = notes.replace(/<p>/g, '<p style="line-height: normal; background-color: #ffffff">');
            notes = notes.replace(/><\/p>/g, '><br></p>');
            console.error(notes);
        }

        let hh = this.state.time.split(':')[0];
        let mm = this.state.time.split(':')[1];

        var rapresentativeNotPresent = '';
        if (this.state.scheduleType == 'company') {
            
            const companyRapresentative = this.currentCompany.rapresentative.split(';');
            const meetingRapresentative = this.state.valueRepresentative;
            companyRapresentative.map(r => {
                var bFound = false;
                for (var i = 0; i < meetingRapresentative.length; i++){
                    if (meetingRapresentative[i].label == r)
                        bFound = true;
                }
                if (bFound == false)
                    rapresentativeNotPresent += r + ';';
            })
        }

        var companyBroker = '';
        let companyId = undefined;
        if (this.props.scheduleType == 'company') {
            companyId = this.props.meeting.company_id;
            companyBroker = this.props.meeting.brokerId;
        }
        else {
            companyId = this.state.value.value.split('-')[0];
            companyBroker = this.state.value.value.split('-')[1];
        }

        if (Utils.checkMeetingPossible(this.props.meetings, this.props.breaks, this.props.scheduleType, companyId, investorIds, this.props.meeting.date, hh, mm, this.state.slots, this.props.meeting.id) == false) return;

        if (this.state.value == null) return;
        if (this.state.value == undefined) return;

        if (this.props.scheduleType == 'company') {
            this.state.value.map(i => investorIds.push(i.value));
            this.state.value.map(i => investorBrokersIds.push(i.broker));
            
            let res = await ManageMeetingService(username, token, currentEventId, this.props.meeting.id, 
                this.props.meeting.date, hh, mm, this.state.slots, companyId, companyBroker, investorIds, investorBrokersIds, false, notes, notesRaw, rapresentativeNotPresent);
        }
        else {
            this.props.meeting.investors.map(i => investorIds.push(i.id));
            this.props.meeting.investors.map(i => {
                if (i.id == this.props.subjectId)
                    investorBrokersIds.push(this.state.brokers[0].value)
                else 
                    investorBrokersIds.push(i.brokerId)
            });

            let res = await ManageMeetingService(username, token, currentEventId, this.props.meeting.id, 
                this.props.meeting.date, hh, mm, this.state.slots, companyId, companyBroker, investorIds, investorBrokersIds, false, notes, notesRaw, rapresentativeNotPresent);
        }
        this.props.onDone();
    }

    handleChangeMultiple = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        this.setState({value: value})
      };

}


const menu = {
    position: 'relative',
    top: '10px',
    display: 'flex',
};

const menuVoice = {
    width: '50%',
    textAlign: 'center',
    border: '1px solid black',
    cursor: 'pointer'
}

const title = {
    top: '10xp',
    width: '100%',
    height: '40px',
    lineHeight: '40px',
    textAlign: 'center',
};

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 0, 
    top: 0, 
    padding: 10
}

const mainClass = {
    position: 'fixed',
    left: '35%',
    top: '10%',
    background: '#ffffff',
    border: '1px solid black',
    padding: '20px',
    overflow: 'scroll',
    height: '600px',
    zIndex: 999
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}


const inputTextDisabled = {
    background: '#eeeeee',
    width: '300px',
    padding: '10px'
}